import { grey } from '@material-ui/core/colors';
import { makeStyles, useTheme } from '@material-ui/core/styles';

export const Theme = useTheme;

export type UserContentStylesProps = {
	canDownloadPdfs: boolean;
	uniqueMediaType: boolean;
	isMobile: boolean;
};

export const useStyles = makeStyles(theme => {
	const downloadMenuMediaHeight = 200;
	const downloadMenuMediaHeightPdfs = 250;

	const downloadMenuMediaSingleHeight = 120;
	const downloadMenuMediaSingleHeightPdfs = 190;
	const downloadMenuMediaSingleSubMenuOpenPDfs = 300;

	const downloadMenuMediaSubMenuOpen = 300;
	const downloadMenuMediaSubMenuOpenPdfs = 350;

	return {
		showroomActionsContainer: {
			display: 'flex',
			marginTop: ({ isMobile }: UserContentStylesProps) => (isMobile ? 15 : 30),
			alignItems: 'center',
			justifyContent: 'flex-end',
			padding: '0 15px'
		},
		showroomActionTab: {
			textTransform: 'none'
		},
		showroomActionBox: {
			cursor: 'pointer',
			display: 'flex',
			alignItems: 'center',
			paddingRight: 50,
			[theme.breakpoints.down('md')]: {
				paddingRight: 0
			},
			color: 'black',
			fontSize: 14
		},
		showroomActionTextMobile: {
			opacity: 1,
			fontWeight: 400
		},
		showroomActionBoxIcon: {
			marginRight: 15,
			color: 'black'
		},
		showroomDownloadMenu: {
			minWidth: 200
		},
		showroomDownloadMenuMobile: {
			width: '100%',
			maxWidth: '100%',
			left: '0px !important',
			position: 'fixed',
			bottom: 0,
			top: 'auto !important',
			borderRadius: 0,
			height: ({ canDownloadPdfs }: UserContentStylesProps) => (canDownloadPdfs ? downloadMenuMediaHeightPdfs : downloadMenuMediaHeight)
		},
		showroomDownloadMenuMobileNoMedia: {
			height: ({ canDownloadPdfs }: UserContentStylesProps) =>
				canDownloadPdfs ? downloadMenuMediaSingleHeightPdfs : downloadMenuMediaSingleHeight
		},
		showroomDownloadMenuMobileSubmenuOpened: {
			height: ({ canDownloadPdfs, uniqueMediaType }: UserContentStylesProps) => {
				if (canDownloadPdfs) return uniqueMediaType ? downloadMenuMediaSingleSubMenuOpenPDfs : downloadMenuMediaSubMenuOpenPdfs;
				else return downloadMenuMediaSubMenuOpen;
			}
		},
		showroomDownloadMenuItem: {
			padding: '15px 30px',
			'&:hover': {
				backgroundColor: 'rgba(0, 199, 149, 0.1)'
			}
		},
		showroomDownloadMenuItemMobile: {
			justifyContent: 'center',
			'&:hover': {
				backgroundColor: 'rgba(0, 199, 149, 0.1)'
			}
		},
		showroomDownloadMenuSubItem: {
			backgroundColor: grey[200]
		},
		showroomDownloadMenuDivider: {
			marginLeft: 30,
			marginRight: 30,
			marginTop: 5,
			marginBottom: 5
		},
		stickyBar: {
			top: 'auto',
			bottom: 0,
			backgroundColor: '#FFF',
			borderRadius: '16px 16px 0px 0px'
		},
		stickyBarMobileOpened: {
			bottom: ({ canDownloadPdfs }: UserContentStylesProps) => (canDownloadPdfs ? downloadMenuMediaHeightPdfs : downloadMenuMediaHeight),
			transition: theme.transitions.create(['bottom'], {
				easing: theme.transitions.easing.sharp,
				duration: theme.transitions.duration.enteringScreen
			})
		},
		stickyBarMobileOpenedNoMedia: {
			bottom: ({ canDownloadPdfs }: UserContentStylesProps) =>
				canDownloadPdfs ? downloadMenuMediaSingleHeightPdfs : downloadMenuMediaSingleHeight
		},
		stickyBarMobileOpenedSubmenuOpened: {
			bottom: ({ canDownloadPdfs, uniqueMediaType }: UserContentStylesProps) => {
				if (canDownloadPdfs) return uniqueMediaType ? downloadMenuMediaSingleSubMenuOpenPDfs : downloadMenuMediaSubMenuOpenPdfs;
				else return downloadMenuMediaSubMenuOpen;
			}
		},
		actionContainer: {
			display: 'flex',
			flexWrap: 'wrap'
		},
		mobileButtonDivider: {
			marginTop: 20,
			marginBottom: 20
		}
	};
});
